function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var getSubTaskProgressStyle = function getSubTaskProgressStyle(prefixCls, token) {
  return _defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty({}, ".colStyle", {
    marginBottom: '16px',
    cursor: 'pointer'
  }), ".rowContent", _defineProperty(_defineProperty(_defineProperty({
    padding: '16px'
  }, ".subTaskItemWrap", {
    backgroundColor: '#F6F6F9',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    padding: '12px 8px',
    borderRadius: '4px',
    gap: '6px',
    minWidth: '240px'
  }), ".subTaskIconWrap", {
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    backgroundColor: '#4C65ED',
    color: 'white'
  }), ".subTaskContent", _defineProperty(_defineProperty(_defineProperty({
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  }, ".subTaskTitle", {
    fontSize: '14px',
    fontWeight: 500,
    color: '#0D1121',
    lineHeight: '20px'
  }), ".subTaskDesc", {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#3D414D',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px'
  }), ".help", {
    fontSize: '12px',
    fontWeight: 400,
    color: '#9EA0A6'
  }))));
};